import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

export interface Theme {
  class: string;
  label: string;
  isDark?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  themes: Theme[] = [
    { class: 'blue', label: 'Light Blue' },
    { class: 'blue', label: 'Dark Blue', isDark: true },
    { class: 'green', label: 'Light Green' },
    { class: 'green', label: 'Dark Green', isDark: true },
    { class: 'purple', label: 'Light Purple' },
    { class: 'purple', label: 'Dark Purple', isDark: true },
  ];
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.setTheme(this.themes[0]);
  }

  setTheme(theme: Theme) {
    this.renderer.setAttribute(
      this.document.documentElement,
      'seech-theme',
      `light-${theme.class}`
    );

    this.renderer.setAttribute(
      this.document.documentElement,
      'data-theme',
      theme.isDark ? 'dark' : ''
    );
  }
}
